import React, { useEffect, useState } from 'react'
import { createTheme, Grid, ThemeProvider } from '@mui/material';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';


import { MainPage } from '../pages/MainPage';
import { Centros } from '../pages/Centros';




import { Login } from '../pages/Login';
import { Ajustes } from '../pages/Ajustes';
import { Usuarios } from '../pages/Usuarios';
import { RolesYDepartamnetos } from '../pages/RolesYDepartamnetos';
import { Confecciones } from '../pages/Confecciones';
import { Maquinas } from '../pages/Maquinas';
import { SalidasProduccion } from '../pages/SalidasProduccion';
import { ParametrosTiempo } from '../pages/ParametrosTiempo';
import { GuiaUsuario } from '../pages/GuiaUsuario';
import { Footer } from '../components/Footer';
import { getSession } from '../services/apis';
import {
    getUsuarioFromSession,
    puedeEditarMaestrosAlmacen,
    puedeEditarMaestrosGlobales,
    puedeGestionarUsuarios,
    puedeSincronizarBusinessCentral,
    puedeVerAjustes,
} from '../utils/permisos';




const theme = createTheme({
    palette: {
        primary: {
            main: '#fea00a',
            light: '#fea00a',
            dark: '#fea00a',
            contrastText: '#F5F5F5',
        },
        secondary: {
            main: '#EEEEEE',
            light: '#EEEEEE',
            dark: '#EEEEEE',
            contrastText: '#313131',
        },
        blanco: {
            main: '#EEEEEE',
            light: '#EEEEEE',
            dark: '#EEEEEE',
            contrastText: '#313131',
        },
        blanco2: {
            main: '#F5F5F5',
            light: '#F5F5F5',
            dark: '#F5F5F5',
            contrastText: '#313131',
        },
        gris: {
            main: '#dadada',
            light: '#dadada',
            dark: '#dadada',
            contrastText: '#313131',
        },
        negro: {
            main: '#313131',
            light: '#313131',
            dark: '#313131',
            contrastText: '#F5F5F5',
        },
    },
});

const RequirePermission = ({ children, permiso }) => {
    const [permitido, setPermitido] = useState(null);

    useEffect(() => {
        const cargarPermisos = async () => {
            try {
                const session = await getSession();
                const usuario = getUsuarioFromSession(session);

                const permisos = {
                    ajustes: puedeVerAjustes(usuario),
                    usuarios: puedeGestionarUsuarios(usuario),
                    roles: puedeGestionarUsuarios(usuario),
                    maestrosGlobales: puedeEditarMaestrosGlobales(usuario),
                    maestrosAlmacen: puedeEditarMaestrosAlmacen(usuario),
                    maestrosBusinessCentral: puedeEditarMaestrosGlobales(usuario) || puedeSincronizarBusinessCentral(usuario),
                };

                setPermitido(Boolean(permisos[permiso]));
            } catch (error) {
                console.error('Error al comprobar permisos:', error);
                setPermitido(false);
            }
        };

        cargarPermisos();
    }, [permiso]);

    if (permitido === null) return null;

    return permitido ? children : <Navigate to="/" replace />;
}

export const Router = () => {

    //global
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const location = useLocation();
    const esPlanificador = location.pathname === '/' || location.pathname === '/pedidos';

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return (
        <ThemeProvider theme={theme}>
            <Grid
                container
                direction="column"
                size={{ xs: 12 }}
                sx={{
                    minHeight: '100vh',
                    justifyContent: "start",
                    alignItems: "start",
                    pb: esPlanificador ? 0 : 5
                }}
            >
                <Routes>
                    <Route element={<PrivateRoute />}>

                        <Route path='*' element={<MainPage />} ></Route>

                        <Route path='/' element={<MainPage />} ></Route>

                        <Route path='/pedidos' element={<MainPage />} ></Route>

                        <Route path='/centros' element={<Centros />} ></Route>

                        <Route path='/ajustes' element={<RequirePermission permiso="ajustes"><Ajustes /></RequirePermission>} ></Route>

                        <Route path='/usuarios' element={<RequirePermission permiso="usuarios"><Usuarios /></RequirePermission>} ></Route>

                        <Route path='/roles-y-departamentos' element={<RequirePermission permiso="roles"><RolesYDepartamnetos /></RequirePermission>} ></Route>

                        <Route path='/confecciones' element={<RequirePermission permiso="maestrosBusinessCentral"><Confecciones /></RequirePermission>} ></Route>

                        <Route path='/tipos-maquinas' element={<RequirePermission permiso="maestrosGlobales"><Maquinas /></RequirePermission>} ></Route>
                        <Route path='/colores-personales' element={<Maquinas soloColores />} />

                        <Route path='/salidas-produccion' element={<RequirePermission permiso="maestrosAlmacen"><SalidasProduccion /></RequirePermission>} ></Route>

                        <Route path='/parametros-tiempo' element={<RequirePermission permiso="maestrosGlobales"><ParametrosTiempo /></RequirePermission>} ></Route>

                        <Route path='/guia' element={<GuiaUsuario />} ></Route>


                    </Route>

                    {/* //global */}
                    <Route path="/login" element={<Login username={username} setUsername={setUsername} password={password} setPassword={setPassword} />}></Route>

                    <Route path="*" element={<Navigate to="/" replace />} />


                </Routes>

                {!esPlanificador && <Footer />}
            </Grid>
        </ThemeProvider>
    )
}
export default Router
